<template>
  <div class="layout">
    <div class="main">
      <div class="logo-bar">
        <img src="../../assets/images/logo.png" class="img" />
      </div>
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item prop="account">
          <el-input v-model="form.account" placeholder="请输入用户名" prefix-icon="el-icon-user">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="form.password" placeholder="请输入密码" prefix-icon="el-icon-lock"
            @keyup.enter.native="handleSubmit"></el-input>
        </el-form-item>
      </el-form>
      <el-button round type="primary" :loading="loading" @click="handleSubmit" class="login-btn">登录</el-button>
    </div>
    <div class="footer">
      <a href="http://beian.miit.gov.cn" target="_blank">京ICP备17043676号-11</a>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { validateForm } from '@utils'
import loginFormjRules from '@utils/rules/loginFormRules'
import { namespace } from 'vuex-class'

const moduleUser = namespace('user')

@Component
export default class Login extends Vue {
  rules = loginFormjRules
  loading = false
  form = {
    account: '',
    password: '',
  }

  @moduleUser.Action
  Login

  async handleSubmit() {
    const valid = await validateForm.call(this, 'form')
    valid && this.login()
  }

  async login() {
    try {
      this.loading = true
      await this.Login(this.form)
      this.$router.push({ path: '/' })
    } catch (error) {
      console.log(error)
      this.$router.push({ path: '/login' })
    } finally {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-image: url('../../assets/images/login.png');

  .main {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 400px;

    .logo-bar {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;

      .img {
        width: 200px;
      }
    }

    .login-btn {
      width: 100%;
      height: 45px;
      background: linear-gradient(180deg, #FFAB40 0%, #F17400 100%), #FFFFFF;
      border-radius: 30px;
    }
  }

  .footer {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
  }
}

/deep/.el-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/deep/.el-input {
  .el-input__inner {
    height: 45px;
    color: #fff;
    border-width: 2px;
    border-radius: 30px;
    background: rgba(255, 255, 255, 0.13);

    &:focus {
      border: 2px solid #fff;
    }
  }
}
</style>
